module.exports = __webpack_public_path__ + "static/media/multisport.4d2f8a62.webp";